module.exports = __webpack_public_path__ + "img/logo.5c88e56e.png";